import React from "react";

import { InputTextarea } from "primereact/inputtextarea";
import { InputText } from "primereact/inputtext";
import { Fieldset } from "primereact/fieldset";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { Button } from "primereact/button";
import moment from "moment";

/** contexts */

/** providers */

/** utils */

/** services */

const History: React.FC<iProps> = ({ person, setVisibleHistory, medicines = [] }) => {
    const RenderFooter = () => (
        <>
            <div className="field col-12 md:col-12 p-5 flex justify-content-end ">
                <Button label="Fechar" icon="pi pi-times" className="p-button-text text-red-500 p-button-sm" onClick={() => setVisibleHistory(false)} />
            </div>
        </>
    );

    return (
        <>
            {person?.calls ? (
                <>
                    {person.calls.map(call => (
                        <div key={`history-${call.id}`} className="flex flex-column md:flex-row flex-wrap ">
                            <div className="col-12 md:col-12">
                                <Fieldset
                                    legend={`${call.mission?.name} - [${moment(call.mission?.start_date).utc().format("DD/MM/YYYY")} - ${moment(
                                        call.mission?.end_date,
                                    )
                                        .utc()
                                        .format("DD/MM/YYYY")}]`}
                                    toggleable
                                    collapsed>
                                    <div className="col-12 md:col-12">
                                        <h5 className="mb-5 ml-1 mt-2" style={{ fontWeight: "normal", fontSize: 12 }}>
                                            Médico: <b>{call.user?.name}</b>
                                        </h5>
                                    </div>
                                    <Fieldset legend="Triagem" toggleable collapsed>
                                        <p>
                                            <b style={{ fontSize: 12 }}>Peso: </b> {call?.sorting?.weight ?? "-"} &nbsp;&nbsp;|&nbsp;&nbsp;
                                            <b style={{ fontSize: 12 }}>Altura: </b> {call?.sorting?.height ?? "-"}
                                        </p>
                                        <p></p>
                                        <p>
                                            <b style={{ fontSize: 12 }}>Pressão arterial: </b> {call?.sorting?.pressure ?? "-"} &nbsp;&nbsp;|&nbsp;&nbsp;
                                            <b style={{ fontSize: 12 }}>IMC: </b> {call?.sorting?.imc ?? "-"}
                                        </p>

                                        <p>
                                            <b style={{ fontSize: 12 }}>Temperatura: </b> {call?.sorting?.temperature ?? "-"}º &nbsp;&nbsp;|&nbsp;&nbsp;
                                            <b style={{ fontSize: 12 }}>Frequencia Respiratória: </b> {call?.sorting?.respiratory_frequency ?? "-"}
                                        </p>

                                        <p>
                                            <b style={{ fontSize: 12 }}>Saturação: </b> {call?.sorting?.saturation ?? "-"}
                                        </p>

                                        <p>
                                            <b style={{ fontSize: 12 }}>Observações </b>
                                            <br />
                                            {call?.sorting?.notes ?? "-"}
                                        </p>
                                    </Fieldset>
                                    <Fieldset className="mt-2" legend="Diagnóstico & Anamnese" toggleable collapsed>
                                        <div className="flex flex-column md:flex-row flex-wrap ">
                                            <div className="field col-12 md:col-6 flex flex-column">
                                                <label htmlFor="diagnosis">Diagnóstico</label>
                                                <InputTextarea
                                                    disabled
                                                    readOnly
                                                    id="diagnosis"
                                                    rows={3}
                                                    style={{ resize: "none" }}
                                                    value={call?.diagnosis}
                                                    autoComplete={"new-password"}
                                                    className={classNames("p-3", {})}
                                                />
                                            </div>

                                            <div className="field col-12 md:col-6 flex flex-column">
                                                <label htmlFor="anamnesis">Anamnese</label>
                                                <InputTextarea
                                                    disabled
                                                    readOnly
                                                    id="anamnesis"
                                                    rows={3}
                                                    style={{ resize: "none" }}
                                                    value={call?.anamnesis}
                                                    autoComplete={"new-password"}
                                                    className={classNames("p-3", {})}
                                                />
                                            </div>
                                        </div>
                                    </Fieldset>

                                    <Fieldset className="mt-2" legend="Receituário" toggleable collapsed>
                                        <div className="flex flex-column md:flex-row flex-wrap ">
                                            <div className="field col-12 md:col-12">
                                                {call && call.items && call.items?.data ? (
                                                    <>
                                                        {call.items.data.map((item: any, index: number) => (
                                                            <div key={`dosage-${index}`} className="flex flex-column md:flex-row flex-wrap ">
                                                                <div className="field col-12 md:col-4">
                                                                    <label htmlFor="start_hour"> Medicamento</label>

                                                                    <Dropdown
                                                                        disabled
                                                                        readOnly
                                                                        style={{ width: "100%", padding: "0.6rem !important" }}
                                                                        value={medicines
                                                                            .map(i => ({ id: i.id, name: `${i.name} (${i.stock})` }))
                                                                            .find(i => `${i.id}` === `${call?.items.data[index].medicine_id}`)}
                                                                        options={medicines.map(i => ({ id: i.id, name: `${i.name} (${i.stock})` }))}
                                                                        optionLabel="name"
                                                                        filter
                                                                        showClear
                                                                        filterBy="name"
                                                                        placeholder="Selecione o medicamento"
                                                                        className={classNames("p-2", {})}
                                                                    />
                                                                </div>

                                                                <div className="field col-12 md:col-2">
                                                                    <label htmlFor="amount"> Quantidade</label>

                                                                    <div className="p-inputgroup">
                                                                        <InputText
                                                                            disabled
                                                                            readOnly
                                                                            id="amount"
                                                                            type={"number"}
                                                                            value={call?.items.data[index].amount}
                                                                            autoComplete={"new-password"}
                                                                            className={classNames("p-3", {})}
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="field col-12 md:col-6">
                                                                    <label htmlFor="dosage"> Dosagem</label>

                                                                    <div className="p-inputgroup">
                                                                        <InputText
                                                                            disabled
                                                                            readOnly
                                                                            id="dosage"
                                                                            type={"text"}
                                                                            value={call?.items.data[index].dosage}
                                                                            autoComplete={"new-password"}
                                                                            className={classNames("p-3", {})}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </>
                                                ) : null}
                                            </div>
                                        </div>
                                    </Fieldset>
                                </Fieldset>
                            </div>
                        </div>
                    ))}
                </>
            ) : null}

            <RenderFooter />
        </>
    );
};

export default History;

interface iProps {
    person: iPeople | undefined;
    setVisibleHistory: Function;
    medicines: iMedicine[];
}
